import React from "react";

const ShopPlaceHolder = () => (
<li className="list-group-item list-group-item-action flex-column align-items-start placeholder">
    <div>
        <div className="d-flex w-100 justify-content-between">
            <div className="mb-1">
                <div className="loading-line"/>
            </div>
        </div>

        <p className="mb-1">
            <div className="loading-line"/>
            <div className="loading-line"/>
            <div className="loading-line"/>
        </p>

        <small className="text-muted">
            <div className="loading-line"/>
        </small>

        <div className="isFloatRight shop_link">
            <small><div className="loading-line"/></small>
        </div>

        <div className="clear"/>

    </div>
</li>

);

export const ShopLoader = () => (
    <>
        {[...Array(2).keys()].map((_, i) => (
            <ShopPlaceHolder key={i} />
        ))}
    </>
);